<template>
  <!-- eslint-disable -->
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 bg-yellow">
      <!-- Brand logo-->
      <!-- <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">PROYECTO MINERIA</h2>
      </b-link> -->
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="12" class="d-flex flex-column align-items-center p-5">
        <div class="w-100 d-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="sideImg" alt="gqr-logo" />
        </div>
        <div class="d-flex flex-column align-items-center auth-bg p-3 p-lg-5 w-full rounded shadow-lg">
          <b-card-title class="mb-1 font-weight-bold text-center" title-tag="h2"> Sistema de Autopartes </b-card-title>
          <!-- form -->
          <validation-observer class="w-100" ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="Usuario o correo" label-for="login-email">
                <validation-provider #default="{ errors }" name="Email" vid="email" rules="required|email">
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>
                </div>
                <validation-provider #default="{ errors }" name="Password" vid="password" rules="required">
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Recuerdamelo
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button type="submit" variant="primary" block :disabled="invalid"> Iniciar Sesion </b-button>
            </b-form>
          </validation-observer>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  VBTooltip
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import AuthService from '@/services/AuthService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/gqr/gqr-logo.webp'),

      // validation rules
      required,
      email
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    }
    // imgUrl() {
    //   if (store.state.appConfig.layout.skin === 'dark') {
    //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //     this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
    //     return this.sideImg
    //   }
    //   return this.sideImg
    // }
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then(async (success) => {
        if (success) {
          const response = await AuthService.login(
            {
              email: this.userEmail,
              password: this.password
            },
            this.$store
          )          
          if (response) {  
            var userData = response
            userData.ability = [{ action: 'manage', subject: 'all' }]
            console.log('userData role', userData.data.role.name)
            userData.role = userData.data.role.name.toLowerCase()
            // userData.avatar = '/img/13-small.d796bffd.png'
            useJwt.setToken(response.token)
            useJwt.setRefreshToken(response.token)
            localStorage.setItem('userData', JSON.stringify(userData))
            localStorage.setItem('accessToken', userData.data.token)
            this.$ability.update(userData.ability)
            // const response1 = await AuthService.menu(this.$store)
            // let navigation = []
            // if (response1.stores.length > 0) {
            //   for (let index = 0; index < response1.stores.length; index++) {
            //     const element = response1.stores[index];
            //     const element1 = response1.stores[index + 1];
            //     navigation.push(element)
            //     if (element && element1) {
            //       if (element.menu_parent_id == element1.menu_parent_id) {
            //         navigation[index].children.push(element)
            //       }
            //     }
            //   }
            // }
            console.log('navigation',navigation)
            console.log('userData nuevo', userData)
            await this.$nextTick();
            this.$router.push({ name: getHomeRouteForLoggedInUser(userData.role, userData.data.access) })
              .catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err;
                }
              })
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Bienvenido ${userData.data.fullname}`,
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: `Inicio de sesion como ${userData.data.role.name}. Listos para comenzar!`,
                  },
                });
              });
          } else {
            this.$swal({
              title: 'Error!',
              text: response.message,
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.bg-yellow {
  background-color: #fcec3870;
}
</style>
